import api from 'utils/api';

/**
 * Fetch order report data with filter parameters.
 * @param {Object} params - Query filters (startDate, endDate, storeId, search, page, limit, sortBy, sortOrder)
 * @returns {Promise<Object>} API response data
 */
export const getOrderReport = async (params) => {
  const cleanParams = {};
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== '') {
        cleanParams[key] = val;
      }
    });
  }
  const res = await api.get('/report/order', { params: cleanParams });
  return res.data;
};
